import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

function Loader({
  color = 'white',
  type,
}: {
  color?: 'white' | 'blue' | 'black' | 'green';
  type?: 'main' | 'small' | 'route';
}) {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  if (type === 'main' || type === 'route') {
    return (
      <div className="bg-glooOffWhite-100">
        {type === 'route' ? null : <div className="bg-glooGrayBorder w-full" style={{ height: 80 }} />}
        <div className="container mx-auto px-4">
          <div className="flex flex-col py-8 items-center">
            <div className="flex flex-row">
              <div className="flex lg:flex-1 z-10 mr-2">
                <Skeleton width={screenWidth / 3} height={screenHeight / 3} />
              </div>
              <div className="flex lg:flex-1 z-10 ml-2">
                <Skeleton width={screenWidth / 3} height={screenHeight / 3} />
              </div>
            </div>
            <div className="flex flex-row pt-4">
              <div className="flex lg:flex-1 z-10 mr-2">
                <Skeleton width={screenWidth / 3} height={screenHeight / 4.5} />
              </div>
              <div className="flex lg:flex-1 z-10 ml-2">
                <Skeleton width={screenWidth / 3} height={screenHeight / 4.5} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="customThryveLoader">
      <div
        className={classNames({
          'bg-white': color === 'white',
          'bg-blueLight': color === 'blue',
          'bg-primary': color === 'green',
          'bg-black': color === 'black',
        })}
      />
      <div
        className={classNames({
          'bg-white': color === 'white',
          'bg-blueLight': color === 'blue',
          'bg-primary': color === 'green',
          'bg-black': color === 'black',
        })}
      />
      <div
        className={classNames({
          'bg-white': color === 'white',
          'bg-blueLight': color === 'blue',
          'bg-primary': color === 'green',
          'bg-black': color === 'black',
        })}
      />
      <div
        className={classNames({
          'bg-white': color === 'white',
          'bg-blueLight': color === 'blue',
          'bg-primary': color === 'green',
          'bg-black': color === 'black',
        })}
      />
    </div>
  );
}

export default Loader;
